export default "__VITE_ASSET__CeH2oh4y__"